import { MapUiTheme } from '../../../common';
import { padding } from '../../../common/theme/utils';

export const sectionTheme = {
  defaultStyles: {
    backgroundColor: (theme: MapUiTheme) => theme.colors.interaction200,
  },
  Padding: {
    zero: {
      ...padding((theme: MapUiTheme) => theme.spacing['0']),
    },
    xs: {
      ...padding((theme: MapUiTheme) => theme.spacing['2'], '0'),
      '@media screen and (min-width: 1024px)': {
        ...padding((theme: MapUiTheme) => theme.spacing['4'], '0'),
      },
    },
    sm: {
      ...padding((theme: MapUiTheme) => theme.spacing['4'], '0'),
      '@media (min-width: 1024px)': {
        ...padding((theme: MapUiTheme) => theme.spacing['8'], '0'),
      },
    },
    md: {
      ...padding((theme: MapUiTheme) => theme.spacing['8'], '0'),
      '@media (min-width: 1024px)': {
        ...padding((theme: MapUiTheme) => theme.spacing['16'], '0'),
      },
    },
    lg: {
      ...padding((theme: MapUiTheme) => theme.spacing['8'], '0'),
      '@media (min-width: 1024px)': {
        ...padding((theme: MapUiTheme) => theme.spacing['32'], '0'),
      },
    },
    xl: {
      ...padding((theme: MapUiTheme) => theme.spacing['16'], '0'),
      '@media (min-width: 1024px)': {
        ...padding((theme: MapUiTheme) => theme.spacing['64'], '0'),
      },
    },
  },
};
